import { Stack, styled } from '@mui/material';

export const DataGridFloatingActionToolbar = styled(Stack)(({ theme }) => {
  const { spacing, shape } = theme;
  const palette = theme.vars.palette;
  return {
    transform: 'translate(-50%,-50%)',
    position: 'absolute',
    paddingLeft: spacing(4),
    paddingRight: spacing(4),
    paddingBottom: spacing(1),
    paddingTop: spacing(1),
    color: palette.common.white,
    left: '50%',
    bottom: spacing(10),
    zIndex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: spacing(2),
    backgroundColor: palette.grey['600'],
    borderRadius: Number(shape.borderRadius) * 4,
    ...theme.applyStyles('dark', { color: palette.background.default }),
  };
});
